import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "../Notification/NotificationManagementPage.css";
import "../Trading/AddCurrencyPairPage.css";
import "./SendEmailPage.css";

const STATIC_USERS = [
  { id: "user_101", name: "Rahul Sharma", email: "rahul.sharma@example.com" },
  { id: "user_202", name: "Priya Patel", email: "priya.patel@example.com" },
  { id: "user_303", name: "Amit Kumar", email: "amit.kumar@example.com" },
  { id: "user_404", name: "Sneha Singh", email: "sneha.singh@example.com" },
  { id: "user_505", name: "Vikram Reddy", email: "vikram.reddy@example.com" },
  { id: "user_606", name: "Anjali Desai", email: "anjali.desai@example.com" },
  { id: "user_707", name: "Raj Mehta", email: "raj.mehta@example.com" },
  { id: "user_808", name: "Kavita Nair", email: "kavita.nair@example.com" },
  { id: "user_909", name: "Arjun Gupta", email: "arjun.gupta@example.com" },
  { id: "user_010", name: "Meera Iyer", email: "meera.iyer@example.com" },
];

const STATIC_SENT_EMAILS = [
  { _id: "em1", to: "rahul.sharma@example.com", toName: "Rahul Sharma", subject: "KYC Verification Required", sentAt: "2025-02-18T10:30:00.000Z" },
  { _id: "em2", to: "priya.patel@example.com", toName: "Priya Patel", subject: "Withdrawal Successful", sentAt: "2025-02-18T09:15:00.000Z" },
  { _id: "em3", to: "amit.kumar@example.com", toName: "Amit Kumar", subject: "New Staking Package Available", sentAt: "2025-02-17T16:45:00.000Z" },
  { _id: "em4", to: "sneha.singh@example.com", toName: "Sneha Singh", subject: "Security Alert - Login from new device", sentAt: "2025-02-17T14:20:00.000Z" },
  { _id: "em5", to: "vikram.reddy@example.com", toName: "Vikram Reddy", subject: "Welcome to the Exchange", sentAt: "2025-02-16T11:00:00.000Z" },
];

const isValidEmail = (str) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);

const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

const TABS = [
  { key: "send", label: "Send Email", icon: "fa-paper-plane" },
  { key: "sent", label: "Sent Emails", icon: "fa-history" },
];

const SendEmailPage = () => {
  const [activeTab, setActiveTab] = useState("send");
  const [form, setForm] = useState({ toEmail: "", subject: "", message: "" });
  const [sentEmails, setSentEmails] = useState(STATIC_SENT_EMAILS);
  const [successModal, setSuccessModal] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionIndex, setSuggestionIndex] = useState(-1);
  const wrapperRef = useRef(null);

  const searchTerm = form.toEmail.trim().toLowerCase();
  const suggestions = searchTerm
    ? STATIC_USERS.filter(
        (u) =>
          u.email.toLowerCase().includes(searchTerm) ||
          u.name.toLowerCase().includes(searchTerm)
      ).slice(0, 10)
    : STATIC_USERS.slice(0, 10);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const updateForm = (key, value) => {
    setForm((f) => ({ ...f, [key]: value }));
    if (key === "toEmail") {
      setShowSuggestions(true);
      setSuggestionIndex(-1);
    }
  };

  const selectSuggestion = (user) => {
    updateForm("toEmail", user.email);
    setShowSuggestions(false);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || suggestions.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSuggestionIndex((i) => (i < suggestions.length - 1 ? i + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSuggestionIndex((i) => (i > 0 ? i - 1 : suggestions.length - 1));
    } else if (e.key === "Enter" && suggestionIndex >= 0 && suggestions[suggestionIndex]) {
      e.preventDefault();
      selectSuggestion(suggestions[suggestionIndex]);
    } else if (e.key === "Escape") {
      setShowSuggestions(false);
      setSuggestionIndex(-1);
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const email = form.toEmail.trim();
    if (!email || !form.subject || !form.message) return;
    if (!isValidEmail(email)) return;
    const user = STATIC_USERS.find((u) => u.email.toLowerCase() === email.toLowerCase());
    setSentEmails((prev) => [
      {
        _id: `em_${Date.now()}`,
        to: email,
        toName: user?.name || email,
        subject: form.subject,
        sentAt: new Date().toISOString(),
      },
      ...prev,
    ]);
    setSuccessModal({ to: email, subject: form.subject, isRegistered: !!user });
    setForm({ toEmail: "", subject: "", message: "" });
    setShowSuggestions(false);
  };

  return (
    <main className="dashboard-main dashboard-subpage notification-management-page">
      <section className="dashboard-hero notification-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Send Email</span>
          </p>
          <h1 className="dashboard-hero__title">Send Email to User</h1>
          <p className="dashboard-hero__subtitle">
            Send to registered users or any email address
          </p>
        </div>
        <div className="notification-hero__icon">
          <i className="fas fa-envelope" />
        </div>
      </section>

      <div className="dashboard-body">
        {sentEmails.length > 0 && (
          <div className="notification-stats send-email-stats">
            <div className="notification-stat-card">
              <span className="notification-stat-card__value">{sentEmails.length}</span>
              <span className="notification-stat-card__label">Total Sent Emails</span>
            </div>
          </div>
        )}

        <div className="notification-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`notification-tab ${activeTab === tab.key ? "notification-tab--active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <i className={`fas ${tab.icon}`} /> {tab.label}
            </button>
          ))}
        </div>

        <div className="notification-content">
          {activeTab === "send" && (
            <section className="notification-section">
              <h2 className="notification-section__title">
                <i className="fas fa-paper-plane" />
                Compose Email
              </h2>
              <form className="notification-form" onSubmit={handleSubmit}>
                <div className="notification-form__group notification-form__group--relative send-email-to-wrap" ref={wrapperRef}>
                  <label>To (Email) <span className="required">*</span></label>
                  <input
                    type="text"
                    placeholder="Type email or search... (registered or any email)"
                    value={form.toEmail}
                    onChange={(e) => updateForm("toEmail", e.target.value)}
                    onFocus={() => setShowSuggestions(true)}
                    onKeyDown={handleKeyDown}
                    autoComplete="off"
                  />
                  {showSuggestions && (
                    <div className="notification-suggestions send-email-suggestions">
                      {suggestions.length > 0 ? (
                        <>
                          <div className="send-email-suggest-header">
                            {searchTerm ? "Matching users" : "Top 10 registered users"}
                          </div>
                          {suggestions.map((u, idx) => (
                            <div
                              key={u.id}
                              role="button"
                              tabIndex={0}
                              className={`notification-suggestion-item ${idx === suggestionIndex ? "send-email-suggest-active" : ""}`}
                              onClick={() => selectSuggestion(u)}
                              onKeyDown={(e) => e.key === "Enter" && selectSuggestion(u)}
                            >
                              <div className="notification-suggestion-name">{u.name}</div>
                              <div className="notification-suggestion-email">{u.email}</div>
                            </div>
                          ))}
                          {searchTerm && suggestions.every((u) => u.email.toLowerCase() !== searchTerm) && (
                            <div className="send-email-suggest-custom">
                              Or send to: <strong>{form.toEmail}</strong> (any email)
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="send-email-suggest-empty">
                          No match. You can enter any email above.
                        </div>
                      )}
                    </div>
                  )}
                  {form.toEmail && !isValidEmail(form.toEmail.trim()) && (
                    <small className="send-email-error">Please enter a valid email address</small>
                  )}
                </div>
                <div className="notification-form__group">
                  <label>Subject <span className="required">*</span></label>
                  <input
                    type="text"
                    placeholder="Email subject"
                    value={form.subject}
                    onChange={(e) => updateForm("subject", e.target.value)}
                  />
                </div>
                <div className="notification-form__group">
                  <label>Message <span className="required">*</span></label>
                  <textarea
                    placeholder="Write your message here..."
                    value={form.message}
                    onChange={(e) => updateForm("message", e.target.value)}
                    rows={5}
                  />
                </div>
                <div className="notification-form__actions send-email-actions">
                  <button type="button" className="send-email-btn-clear" onClick={() => setForm({ toEmail: "", subject: "", message: "" })}>
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="notification-btn-send"
                    disabled={!form.toEmail.trim() || !isValidEmail(form.toEmail.trim()) || !form.subject || !form.message}
                  >
                    <i className="fas fa-paper-plane" /> Send Email
                  </button>
                </div>
              </form>
            </section>
          )}

          {activeTab === "sent" && (
            <section className="notification-section">
              <h2 className="notification-section__title">
                <i className="fas fa-list-alt" />
                Sent Emails List ({sentEmails.length})
              </h2>
              {sentEmails.length === 0 ? (
                <div className="notification-empty">
                  <i className="fas fa-envelope" />
                  <p>No emails sent yet</p>
                </div>
              ) : (
                <div className="notification-table-wrap">
                  <table className="notification-table">
                    <thead>
                      <tr>
                        <th>Sent At</th>
                        <th>To</th>
                        <th>Subject</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sentEmails.map((row) => (
                        <tr key={row._id}>
                          <td>{formatDate(row.sentAt)}</td>
                          <td>
                            <div><strong>{row.toName}</strong></div>
                            <div className="notification-suggestion-email">{row.to}</div>
                          </td>
                          <td>{row.subject}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          )}
        </div>
      </div>

      {successModal && (
        <div className="addpair-success-overlay" onClick={() => setSuccessModal(null)}>
          <div className="addpair-success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="addpair-success-icon"><i className="fas fa-check-circle" /></div>
            <h3>Email Sent Successfully</h3>
            <p>Email has been sent (static demo):</p>
            <div className="addpair-success-details">
              <div className="addpair-success-row"><span>To</span><strong>{successModal.to}</strong></div>
              <div className="addpair-success-row"><span>Subject</span><strong>{successModal.subject}</strong></div>
              {!successModal.isRegistered && (
                <div className="addpair-success-row">
                  <span>Type</span><strong>External (non-registered)</strong>
                </div>
              )}
            </div>
            <button type="button" className="cp-btn cp-btn--primary" onClick={() => setSuccessModal(null)}>Done</button>
          </div>
        </div>
      )}
    </main>
  );
};

export default SendEmailPage;
